module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgPHBvbHlnb24gZmlsbD0iI0ZGRiIgcG9pbnRzPSIyMS41NCAyMy42NyAxMiAxNC4xMTUgMi40NiAyMy42NyAuMzMgMjEuNTQgOS44ODUgMTIgLjMzIDIuNDYgMi40NiAuMzMgMTIgOS44ODUgMjEuNTQgLjM0NSAyMy42NTUgMi40NiAxNC4xMTUgMTIgMjMuNjU1IDIxLjU0Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./images/gridicons-cross.svg
// module id = 167
// module chunks = 0